export const ADDITIONAL_FEE_TYPES = {
	DELIVERY: 'delivery',
	CHEHFERO_SERVICES_FEE: 'chefhero_services_fee',
	OTHER: 'other'
};
